<nav class="account-details-nav" [class.account-details-nav--inset]="isProfilePage">
  <ul class="account-details-nav-list">
    <li *ngFor="let item of navItems">
      <a
        *ngIf="item.route; else inertItem"
        class="nav-row"
        [routerLink]="item.route"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{ item.labelKey | translate : { fgbdefault: item.fgbDefault } }}"
      >
        <span class="icon nav-row-icon" [ngClass]="item.iconFont || 'material-icons'" aria-hidden="true">{{ item.icon }}</span>
        <span class="nav-row-label">{{ item.labelKey | translate : { fgbdefault: item.fgbDefault } }}</span>
        <span class="nav-row-badge" *ngIf="item.badgeKey">{{
          item.badgeKey | translate : { fgbdefault: item.badgeDefault }
        }}</span>
        <span class="icon material-icons nav-row-chevron d-lg-none" aria-hidden="true">chevron_right</span>
      </a>
      <ng-template #inertItem>
        <div class="nav-row nav-row-inert">
          <span class="icon nav-row-icon" [ngClass]="item.iconFont || 'material-icons'" aria-hidden="true">{{ item.icon }}</span>
          <span class="nav-row-label">{{ item.labelKey | translate : { fgbdefault: item.fgbDefault } }}</span>
          <span class="icon material-icons nav-row-chevron d-lg-none" aria-hidden="true">chevron_right</span>
        </div>
      </ng-template>
    </li>
  </ul>
</nav>
